// User-facing copy: shelf. Moved from the web app (components/Book3D.tsx, components/BookBits.tsx, components/BookPicker.tsx, components/BookSearch.tsx, components/NextBookVote.tsx, components/PickBook.tsx, components/Stars.tsx, components/Suggestion.tsx, pages/club/RecapPage.tsx, pages/club/ShelfTab.tsx, pages/club/SuggestionsPage.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** components/Book3D.tsx */
export const book3d = {
    wantToRead: "Want to read",
    readIt: (name) => `${name} · read it`,
    days: (days) => ` · ${days} days`,
    rating: "rating",
    ratings: "ratings",
    unrated: "unrated",
};
/** components/BookBits.tsx */
export const bookBits = {
    unknownAuthor: "Unknown author",
    pages: (pages) => `${pages} pages`,
};
/** components/BookPicker.tsx */
export const bookPicker = {
    earlier: "Earlier",
    readingNow: "reading now",
    finished: "finished",
    whichBook: "Which book",
    finished2: "Finished",
    showMore: (length) => `Show ${length} more`,
    finishedOn: (fullDate) => `finished on ${fullDate}`,
};
/** components/BookSearch.tsx */
export const bookSearch = {
    searchHardcoverByTitle: "Search Hardcover by title or author",
    searching: "Searching…",
    nothingMatchedTryFewer: "Nothing matched. Try fewer words.",
    adding: "Adding…",
    onShelf: "On shelf",
    add: "Add",
    showMore: (x) => `Show ${x} more`,
};
/** components/NextBookVote.tsx */
export const nextBookVote = {
    openAVoteOn: "Open a vote on the next book",
    openAVote: "Open a vote",
    theBooksOnDeck: "The books on deck become the ballot, and hold still until the vote closes.",
    closes: "Closes",
    whenAnAdminCloses: "when an admin closes it",
    atTheMeeting: (when) => `at the meeting · ${when}`,
    inDays: (d, when) => `in ${d} days · ${when}`,
    openTheVote: "Open the vote",
    cancel: "Cancel",
    thatBook: "that book",
    voteOnTheNext: "Vote on the next book",
    ofVoted: (x, voted, members, x2) => `${x} · ${voted} of ${members}  ${x2} voted`,
    closes2: (when) => `Closes ${when}`,
    openUntilAnAdmin: "Open until an admin closes it",
    has: "has",
    have: "have",
    tickEveryBookYou: "Tick every book you'd happily read. Most ticks wins.",
    youVeVotedTap: "You've voted. Tap a book to change your ticks.",
    tapBooksInThe: "Tap books in the order you'd read them. First place scores most.",
    aBookWasAdded: "A book was added since you voted. Slot it in if you'd read it.",
    youVeVotedTap2: "You've voted. Tap a book to change your order.",
    closeTheVote: "Close the vote",
    theVoteIsIn: "The vote is in",
    itSATie: "It's a tie",
    theVoteClosed: "The vote closed",
    dismiss: "Dismiss",
    closedOfVoted: (x, voted, members) => `Closed ${x} · ${voted} of ${members} voted`,
    nobodyRankedAnything: "Nobody ranked anything.",
    point: "point",
    points: "points",
    firstChoice: (length, x) => `${length} first choice${x}`,
    s: "s",
    pickThisOne: "Pick this one",
    random: "random",
    letTheLampDecide: "Let the lamp decide",
    anAdminStartsIt: "An admin starts it when the club is ready.",
    runnerUp: (title, points, x) => `Runner-up: ${title}, ${points}  ${x}`,
    tickedTapToUntick: "Ticked, tap to untick",
    tickThisBook: "Tick this book",
    rankedTapToRemove: (rank) => `Ranked ${rank}, tap to remove`,
    rankThisBook: "Rank this book",
    tick: "tick",
    ticks: "ticks",
    pts: (points) => `${points} pts`,
};
/** components/PickBook.tsx */
export const pickBook = {
    pickTheFirstBook: "Pick the first book",
    pickTheNextBook: "Pick the next book",
    addABookYou: "Add a book you've read before",
    close: "Close",
    itBecomesTheClub: "It becomes the club's book straight away, and everyone's progress starts here.",
    itGoesStraightOnto: "It goes straight onto the Finished shelf. Add as many as you like.",
    addedSearchForAnother: "Added. Search for another, or close.",
    change: "Change",
    start: "Start ",
    forTheClub: " for the club?",
    startedOptional: "Started (optional)",
    finishedOptional: "Finished (optional)",
    working: "Working…",
    startIt: "Start it",
    addToFinished: "Add to Finished",
    back: "Back",
};
/** components/Stars.tsx */
export const stars = {
    outOf5Stars: (value) => `${value} out of 5 stars`,
    yourRating: "Your rating",
    notRated: "not rated",
    stars: (shown) => `${shown} stars`,
};
/** components/Suggestion.tsx */
export const suggestion = {
    th: "th",
    st: "st",
    nd: "nd",
    rd: "rd",
    youVeBroughtThis: "You've brought this one back once already",
    bringItBack: "Bring it back",
    wantToRead: "Want to read ",
    wantToRead2: (x) => `${x}Want to read `,
    suggestedBy: (x) => `suggested by ${x}`,
    you: "you",
    suggested: "suggested",
    onDeck: "on deck",
    inTheRunning: (ordinal) => `${ordinal} in the running`,
    quietSince: (day) => `quiet since ${day}`,
    wantedIt: (wanted) => `${wanted} wanted it`,
    theClubReadThis: (readIn) => `the club read this in ${readIn}`,
    movesToPastOn: (day) => ` · moves to Past on ${day} unless someone else wants it`,
    about: (title) => `About ${title}`,
    pinned: "pinned",
    takeItOffThe: "Take it off the shelf for good?",
    remove: "Remove",
    keep: "Keep",
    more: "More",
    startReading: "Start reading",
    unpinFromOnDeck: "Unpin from on deck",
    pinToOnDeck: "Pin to on deck",
    moveToPast: "Move to Past",
    day: "day",
    days: "days",
    aboutWeeks: (round) => `about ${round} weeks`,
    pages: (pages, span) => `${pages} pages · ${span}`,
    pagesAtADay: (pages, span, pace) => `${pages} pages · ${span} at ${pace} a day`,
    whyThisOneOne: "Why this one? One line for the club.",
    save: "Save",
    cancel: "Cancel",
    skip: "Skip",
    pages2: (pages) => `${pages} pages`,
    about2: (days, x) => `about ${days} ${x}`,
};
/** pages/club/RecapPage.tsx */
export const recap = {
    finishedNoRating: "Finished, no rating",
    stoppedPartway: "Stopped partway",
    stillReading: "Still reading",
    readItBefore: "Read it before",
    neverStarted: "Never started",
    shelf: "Shelf",
    pages: (pages) => ` · ${pages} pages`,
    finished: "Finished ",
    days: " days",
    meeting: "meeting",
    meetings: "meetings",
    ofFinished: (length, length2, x) => `${length} of ${length2} finished${x}`,
    firstReactions: "First reactions",
    firstReactionsUnlockWhen: "First reactions unlock when you finish.",
    theMeeting: "The meeting",
    theMeetings: "The meetings",
    hosted: (name) => `${name} hosted`,
    sealedUntilYouFinish: "Sealed until you finish: the note and the questions are full of the ending.",
    nobodyWroteANote: "Nobody wrote a note for this one.",
    whatWeTalkedAbout: "What we talked about",
    sQuestion: (name) => `· ${name}'s question`,
    talkedAbout: "Talked about",
    linesWeKept: "Lines we kept",
    sealedUntil: (position) => `Sealed until ${position}%.`,
    reply: "reply",
    replies: "replies",
    predictions: "Predictions",
    sealedBeforeOpenedAt: (spot) => `Sealed before ${spot}, opened at the end.`,
    theyOpenWhenYou: "They open when you finish.",
    notesLeftInThis: "Notes left in this book",
    everyNoteSomeoneLeft: "Every note someone left forward, including ones you were already past.",
    at: (x, spot, x2) => `${x} · at ${spot}${x2}`,
    you: "You",
    edited: " · edited",
    aboutTheBook: "About the book",
    contentWarnings: "Content warnings:",
    openOnHardcover: "Open on Hardcover ↗",
    theClubSVerdict: "The club's verdict",
    rating: "rating",
    ratings: "ratings",
    nobodyHasRatedIt: "Nobody has rated it yet.",
    didnTFinish: (dnfCount) => `${dnfCount} didn't finish`,
    theConversation: "The conversation",
    message: "message",
    messages: "messages",
    nobodySaidAnything: "Nobody said anything",
    openTalkAndBe: "Open Talk and be the first",
    mostReplied: (name, replyCount, x) => `${name} · most replied · ${replyCount}  ${x}`,
    sealedUntilReadOn: (position) => `Sealed until ${position}%. Read on to unlock.`,
    thread: "thread",
    threads: "threads",
    sealedForYou: (sealedForYou) => ` · ${sealedForYou} sealed for you`,
    to: (d, d2) => ` · ${d} to ${d2}`,
    yourNotes: (myNotes) => `Your notes · ${myNotes}`,
    yourNotes2: "Your notes",
    onlyYouCanSee: "Only you can see these",
    youLeftThisAt: (spot, name) => `You left this at ${spot} · for ${name}`,
    bookActions: "Book actions",
    editDates: "Edit dates",
    reopenMakeItCurrent: "Reopen · make it current again",
    finishedByMistakeMake: "Finished by mistake? Make ",
    currentAgainRatingsReactions: " current again. Ratings, reactions and ticks all stay.",
    reopen: "Reopen",
    cancel: "Cancel",
    findSomeone: "Find someone",
    left: " · left",
    nobodyByThatName: "Nobody by that name here.",
    showAll: (length) => `Show all ${length}`,
};
/** pages/club/ShelfTab.tsx */
export const tab = {
    finished: "finished ",
    read: (toLocaleDateString) => `Read · ${toLocaleDateString}`,
    you: "You",
    andMore: (join, x) => `${join} and ${x} more`,
    ofHaveReadIt: (length, members) => `${length} of ${members} have read it`,
    readIt: (list) => `${list} read it`,
    sitItOut: (x) => ` · ${x} sit it out`,
    youD: "you'd",
    would: (name) => `${name} would`,
    wouldSitItOut: (length) => ` · ${length} would sit it out`,
    wouldSitItOut2: " · would sit it out",
    readItAgain: "Read it again?",
    happyTo: "Happy to",
    iDSitIt: "I'd sit it out",
    havenTReadIt: "Haven't read it",
    cancel: "Cancel",
    pickedByVoteOf: (points, x, voters, members, x2) => `Picked by vote · ${points} ${x}, ${voters} of ${members} voted${x2}`,
    point: "point",
    points: "points",
    tieBroken: " · tie broken",
    your: "Your",
    s: (name) => `${name}'s`,
    recap: (title) => `${title}: recap`,
    close: "Close",
    pinned: "pinned",
    wantToReadIt: (x) => `${x} want to read it`,
    unrated: "unrated",
    onDeck: "On deck",
    chosenByAdmins: "chosen by admins",
    heldStillUntilThe: "held still until the vote closes",
    theMostWanted: (length) => `the ${length} most wanted`,
    itSYourTurn: "It's your turn to pick",
    itSSTurn: (name) => `It's ${name}'s turn to pick`,
    startAnyBookOn: "Start any book on deck or in the suggestions.",
    then: (x) => `Then ${x}.`,
    nothingOnDeckYet: "Nothing on deck yet",
    suggestABook: "Suggest a book",
    tapWantToRead: "Tap “Want to read” on a suggestion and the most wanted come up here.",
    theBooksTheClub: "The books the club wants to read next will wait here.",
    suggestions: "Suggestions",
    everythingSuggestedIsOn: "Everything suggested is on deck · add another",
    suggestTheFirstBook: "Suggest the first book",
    book: "book",
    books: "books",
    newThisWeek: (newThisWeek) => ` · ${newThisWeek} new this week`,
    finished2: "Finished",
    pages: (toLocaleString) => ` · ${toLocaleString} pages`,
    since: (since) => ` · since ${since}`,
    nothingFinishedYet: "Nothing finished yet",
    addBooksYouVe: "Add books you've read before",
    booksTheClubHas: "Books the club has read together will stand here.",
    undated: "Undated",
    th: "th",
    st: "st",
    nd: "nd",
    rd: "rd",
    inPast: "in Past",
    onDeckPinned: "on deck · pinned",
    onDeck2: "on deck",
    inTheRunning: (rank, x) => `${rank}${x} in the running`,
    pages2: (pages) => ` · ${pages} pages`,
    inPast2: "In Past",
    suggested: "Suggested",
    of: (ordinalOf, x) => `${ordinalOf} of ${x}`,
    you2: "you",
    edit: "edit",
    addANoteOn: "Add a note on why you suggested it",
    theClubReadThis: (readIn) => `the club read this in ${readIn}`,
    suggested2: (day) => `suggested ${day}`,
    suggestedBy: (x, day) => `suggested by ${x}, ${day}`,
    someone: "someone",
    movesToPastOn: (day) => `Moves to Past on ${day} unless someone else wants it.`,
    wantToReadIt2: (wanted) => `${wanted} want to read it`,
    readItBefore: (length, x, x2) => `${length}  ${x} read it before${x2}`,
    has: "has",
    have: "have",
    iVeReadThis: "I've read this",
    change: (x, x2) => `${x}${x2} · change`,
    youDSitIt: "You'd sit it out",
    youDReRead: "You'd re-read it",
    fromYourHardcoverShelf: " · from your Hardcover shelf",
    more: "More",
    unpinFromOnDeck: "Unpin from on deck",
    pinToOnDeck: "Pin to on deck",
    moveToFinishedShelf: "Move to finished shelf",
    moveToPast: "Move to Past",
    remove: "Remove",
    takeItOffThe: "Take it off the shelf?",
    keep: "Keep",
    aboutTheBook: "About the book",
    contentWarnings: (length) => `Content warnings · ${length}`,
    openOnHardcover: "Open on Hardcover ↗",
    suggestedByYou: "suggested by you",
    suggestedBy2: (name) => `suggested by ${name}`,
    about: (title) => `About ${title}`,
    addedSinceYouVoted: "added since you voted",
    readItBeforeChange: "Read it before · change",
    pick: (x) => `${x} pick`,
    more2: (running, x, x2) => `${running} more ${x}${x2}`,
    pages3: (pages) => `${pages} pages`,
};
/** pages/club/SuggestionsPage.tsx */
export const suggestions = {
    addedYourInterestIn: (title) => `Added your interest in ${title}.`,
    readingNow: "Reading now",
    wanted: "Wanted",
    wantToRead: "Want to read",
    already: (x, x2) => `Already ${x}${x2}`,
    onDeck: "on deck",
    inTheRunning: "in the running",
    suggestedBy: (x) => `, suggested by ${x}`,
    you: "you",
    bringItBack: "Bring it back",
    inPastSuggestedBy: (x) => `In Past, suggested by ${x}`,
    someone: "someone",
    theClubReadThis: (getFullYear) => `The club read this in ${getFullYear}. You can suggest a re-read.`,
    keptInTheRunning: (keep) => `kept in the running above this line · ${keep} books`,
    shelf: "Shelf",
    addABook: "Add a book",
    suggestions: "Suggestions",
    whoseSuggestions: "Whose suggestions",
    everyoneS: "Everyone's",
    mine: "Mine",
    done: "Done",
    youHaveOfSuggestions: (active, cap) => `You have ${active} of ${cap} suggestions going.`,
    seeYours: "See yours",
    suggested: (title) => `Suggested ${title}.`,
    tellTheClubWhy: "Tell the club why, in a line. It shows inside the cover and on the book.",
    searchSuggestionsAndPast: "Search suggestions and Past",
    newThisWeek: "New this week",
    mostWanted: "Most wanted",
    afterTheOnDeck: (length) => `after the ${length} on deck`,
    nothingInTheRunning: "Nothing in the running matches.",
    nothingSuggestedYetAdd: "Nothing suggested yet. Add the first book.",
    everythingInTheRunning: "Everything in the running is on deck or new this week.",
    pastSuggestions: "Past suggestions",
    quietForDays: (retireDays) => ` · quiet for ${retireDays} days`,
    yours: "Yours",
    ofGoing: (active, cap) => `${active} of ${cap} going`,
    youHavenTSuggested: "You haven't suggested anything that's still in the running.",
    yoursInPast: "Yours in Past",
};
//# sourceMappingURL=shelf.js.map